<script>
import entry from '../../entry';
import _2 from './_2.vue';

const components = { _2 };
const map = {
  2: '_2'
};

export default entry({
  name: 'reservation-list-entry',
  components,
  map
});
</script>
